// extracted by mini-css-extract-plugin
export var filterIncDec = "_3w-0";
export var leftBorder = "_3w-1";
export var rightBorder = "_3w-2";
export var stringInput = "_3w-3";